import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Pagination from "../../common/Pagination";
import {
  PendingLeadList,
  assignLeadStore,
} from "../../redux/services/AssignTask Services/AssignTask.Services";
import { STATUS_OPTIONS, STATUS_BADGE } from '../../Constant/leadConstent';
import { successToast, errorToast } from "../../Utils/toast";

function AssignTasksList() {
  const navigate = useNavigate();
  const { id } = useParams();

  // ================= STATES =================
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);

  const [totalPages, setTotalPages] = useState(1);
  const [totalLeads, setTotalLeads] = useState(0);

  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [pendingLeads, setPendingLeads] = useState([]);
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [assignLoading, setAssignLoading] = useState(false);

  // ================= FETCH LEADS =================
  const fetchPendingLeads = async (pageNo = 1, isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }
      const payload = {
        page: pageNo,
        per_page: limit,
      };
      const res = await PendingLeadList(payload);
      const leads = res?.data || [];

      setPendingLeads(leads);
      setPage(res?.current_page || 1);
      setTotalPages(res?.last_page || 1);
      setTotalLeads(res?.total || leads.length);
    } catch (error) {
      console.log(error);
      errorToast("Failed to load leads");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingLeads(1, true);
  }, []);

  // ================= SELECT ALL =================
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedLeadIds(pendingLeads.map((l) => l.id));
    } else {
      setSelectedLeadIds([]);
    }
  };
  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchPendingLeads(newPage);
    }
  };
  // ================= TOGGLE SINGLE =================
  const toggleLeadSelection = (id) => {
    setSelectedLeadIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // ================= ASSIGN LEADS =================
  const assignSelectedLeads = async () => {
    if (selectedLeadIds.length === 0) {
      return Swal.fire({
        title: "No Selection",
        text: "Please select at least one lead to assign",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }

    try {
      setAssignLoading(true);

      const payload = {
        user_id: id, // ✅ Using staff ID from URL
        task_ids: selectedLeadIds,
      };

      console.log("Sending Payload:", payload);

      const response = await assignLeadStore(payload);

      if (response?.status === true || response?.success === true) {
        // Remove assigned leads from UI
        setPendingLeads((prev) =>
          prev.filter((lead) => !selectedLeadIds.includes(lead.id))
        );
        setSelectedLeadIds([]);

        successToast(response?.message || "Tasks assigned successfully 🚀");
        navigate("/lead-staff-list")
      } else {
        errorToast(response?.message || "Assignment failed");
      }
    } catch (error) {
      console.error("Assignment Error:", error);
      errorToast(error?.data?.message || "Assignment failed");
    } finally {
      setAssignLoading(false);
    }
  };

  // ================= LOADING =================
  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div className="main_page">
   
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <h4 className="mb-0">Assign Tasks</h4>

            <div className="d-flex gap-2">
              <button
                className="add-btn"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                className="add-btn"
                onClick={() => navigate("/add-staff")}
              >
                Add Staff
              </button>

              <button
                className="add-btn"
                onClick={assignSelectedLeads}
                disabled={assignLoading || selectedLeadIds.length === 0}
              >
                {assignLoading
                  ? "Assigning..."
                  : `Assign Selected (${selectedLeadIds.length})`}
              </button>
            </div>
          </div>

          {totalLeads > limit && (
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">

              {/* <div className="d-flex align-items-center gap-2">
      <label className="mb-0">Show</label>

      <select
        className="form-select form-select-sm"
        value={limit}
        onChange={(e) => {
          const newLimit = Number(e.target.value);

          setLimit(newLimit);
          setPage(1);

          fetchPendingLeads(1);
        }}
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
    </div> */}

              <div className="col-12 d-flex justify-content-end">

                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          )}
            <div className="st-wrapper-card text-center">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle mb-0">
                <thead className="">
                  <tr>
                    <th >
                      <input
                        type="checkbox"
                        checked={
                          pendingLeads.length > 0 &&
                          selectedLeadIds.length === pendingLeads.length
                        }
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>#</th>
                    <th>Lead Name</th>
                    <th>Contact</th>
                    <th>Status</th>
                    {/* <th>Sub Status</th> */}
                  </tr>
                </thead>

                <tbody>
                  {tableLoading ? (
                    <tr>
                      <td colSpan="6" className="text-center py-5">
                        <div className="spinner-border text-primary"></div>
                      </td>
                    </tr>
                  ) : pendingLeads.length > 0 ? (
                    pendingLeads.map((lead, index) => (
                      <tr key={lead.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedLeadIds.includes(lead.id)}
                            onChange={() => toggleLeadSelection(lead.id)}
                          />
                        </td>

                        <td>{(page - 1) * limit + index + 1}</td>

                        <td>{lead.name || "N/A"}</td>

                        <td>{lead.mobile || lead.email || "N/A"}</td>

                        {/* <td>
          <span className="">
            {lead.status }
          </span>
        </td> */}
                        <td>
                          <span
                            className={`status-badge ${STATUS_BADGE[lead.status]
                              }`}
                          >
                            {lead.status || "-"}
                          </span>
                        </td>
                        {/* <td>{lead.sub_status || "N/A"}</td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        No pending leads found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {totalLeads > limit && (
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
   
  );
}

export default AssignTasksList;